export const credential_types = {
  'dial-call': {
    text: 'Dial Call',
    value: 'dial-call'
  },
  'dial-receive-jitsi-call': {
    text: 'Dial And Receive Jitsi Call',
    value: 'dial-receive-jitsi-call'
  },
  'dial-receive-call': {
    text: 'Dial And Receive Call',
    value: 'dial-receive-call'
  },
}